import Vue from 'vue'
import App from './App.vue'
import router from './router';
import './scss/style.scss';
import Vant from 'vant';
import 'vant/lib/index.css';
import { Locale } from 'vant';
import viVN from 'vant/es/locale/lang/vi-VN';
import BoxView from './components/BoxView.vue';

Vue.component('box-view', BoxView);
import MoneyInput from './components/MoneyInput.vue';
Vue.component('money-input', MoneyInput);
import FormattedStepper from './components/FormattedStepper.vue';
Vue.component('formatted-stepper', FormattedStepper);

Locale.use('vi-VN', viVN);

window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


const Cookie = require('vue-cookie');

const Utf8 = require('utf8');

const Base64 = require('base-64');

const Md5 = require('md5');

Vue.use(Vant);
Vue.use(Cookie);

// Filter định dạng số: 1000.00 -> 1.000
// Filter định dạng số: 1000.00 -> 1.000
Vue.filter('formatNumber', function (value) {
    if (value === undefined || value === null) return '0';
    return Number(value).toLocaleString('vi-VN', { maximumFractionDigits: 0 });
});

// Filter định dạng tiền tệ: 1000.00 -> 1.000₫
Vue.filter('formatCurrency', function (value) {
    if (value === undefined || value === null) return '0₫';
    return Number(value).toLocaleString('vi-VN', { maximumFractionDigits: 0 }) + '₫';
});

Vue.config.productionTip = false

const _app = new Vue({

    router,

    render: h => h(App),

    data: {

        ck_auth: 'opt_ck2884',

        ck_cart: 'opt_ck2278',

        ck_view: 'opt_ck8439',

        ck_order_field: 'opt_ck34353',

        ck_order_number: 'opt_ck686237',

        page_title: '',

        loading_page: false,

        auth: null,

        appType: window.appType,

        api: axios.create({

            baseURL: process.env.VUE_APP_API_URL || 'https://api.phanmemlogach.cuongdev.pro.vn/api',

            headers: {

                'Accept': 'application/json'

            }

        }),

        alert_container: { el: null, child: [] },

        notify_container: {},

        show_error_401: false,

        list_sort_type: [

            { value: 'time', title: 'Mới nhất' },

            { value: 'price-asc', title: 'Giá tăng dần' },

            { value: 'price-desc', title: 'Giá giảm dần' }

        ],

        list_rank: {

            normal: 'Thường',

            copper: 'Đồng',

            silver: 'Bạc',

            gold: 'Vàng',

            diamond: 'Kim cương'

        },

        sort_type: '',

        rank: 'normal',

        unreadNotiCount: 0,

        discount: null

    },

    methods: {

        setAuth(auth) {

            if (auth) {

                this.api.defaults.headers.common['User-Token'] = auth.token;

                this.auth = auth;

                this.$cookie.set(this.ck_auth, Base64.encode(auth.id + '-' + auth.token), 365);
                this.$cookie.set('opt_role', Base64.encode(auth.role), 365);
                this.getToken();

            } else {

                this.api.defaults.headers.common['User-Token'] = '';

                this.auth = null;

                this.$cookie.delete(this.ck_auth);
                this.$cookie.delete('opt_role');

            }

        },

        setSortType(sort) {

            if (!this.list_sort_type.some(_sort => (_sort.value == sort))) {

                sort = 'time';

            }



            this.sort_type = sort;

            this.api.defaults.headers.common['Sort-Type'] = sort;

        },

        alert(message, title, type) {

            return new Promise((resolve, reject) => {

                if (typeof title == 'undefined') {

                    title = '';

                }



                if (typeof type == 'undefined') {

                    type = '';

                }



                let confirm = false;

                let prompt = false;

                if (type == 'confirm') {

                    confirm = true;

                    type = 'question';

                } else if (type == 'prompt') {

                    prompt = true;

                    type = '';

                }



                let _alert = document.createElement('div');

                _alert.className = 'm-alert';



                if (type != '' || title != '') {

                    let _header = document.createElement('div');

                    _header.className = 'm-alert-header';



                    if (type != '') {

                        let _icon = document.createElement('div');

                        _icon.className = `m-alert-icon m-alert-icon-${type}`;

                        _header.appendChild(_icon);

                    }



                    if (title != '') {

                        let _title = document.createElement('div');

                        _title.className = 'm-alert-title';

                        _title.innerHTML = title;



                        _header.appendChild(_title);

                    }



                    _alert.appendChild(_header);

                }



                let _content;

                if (prompt) {

                    _content = document.createElement('input');

                    _content.type = 'text';

                    _content.className = 'form-control m-alert-input';

                    _content.value = message;

                } else {

                    _content = document.createElement('div');

                    _content.className = 'm-alert-content';

                    _content.innerHTML = message;

                }



                _alert.appendChild(_content);



                let _action = document.createElement('div');

                _action.className = 'm-alert-action';



                let _ok = document.createElement('button');

                _ok.type = 'button';

                _ok.className = 'btn btn-primary';

                _ok.innerHTML = 'OK';

                _ok.onclick = () => {

                    _alert.classList.add('m-alert-fade-out');

                    setTimeout(() => {

                        _alert.remove();

                        this.alert_container.child.pop();

                        if (this.alert_container.child.length == 0) {

                            this.alert_container.el.remove();

                            this.alert_container.el = null;

                        } else {

                            let len = this.alert_container.child.length;

                            this.alert_container.child[len - 1].style.display = 'block';

                        }

                    }, 300);



                    if (prompt) {

                        resolve(_content.value);

                    } else {

                        resolve('');

                    }

                }



                _action.appendChild(_ok);



                if (confirm || prompt) {

                    let _close = document.createElement('button');

                    _close.type = 'button';

                    _close.className = 'btn btn-secondary';

                    _close.innerHTML = 'Đóng';

                    _close.onclick = () => {

                        _alert.classList.add('m-alert-fade-out');

                        setTimeout(() => {

                            _alert.remove();

                            this.alert_container.child.pop();

                            if (this.alert_container.child.length == 0) {

                                this.alert_container.el.remove();

                                this.alert_container.el = null;

                            } else {

                                let len = this.alert_container.child.length;

                                this.alert_container.child[len - 1].style.display = 'block';

                            }

                        }, 300);



                        reject();

                    }



                    _action.appendChild(_close);

                }



                _alert.appendChild(_action);



                if (this.alert_container.el == null) {

                    let _container = document.createElement('div');

                    _container.className = 'm-alert-container';



                    document.body.appendChild(_container);

                    this.alert_container.el = _container;

                } else {

                    let len = this.alert_container.child.length;

                    this.alert_container.child[len - 1].style.display = 'none';



                    let _index = len + 1;

                    _alert.style.zIndex = _index;

                }



                this.alert_container.el.appendChild(_alert);

                this.alert_container.child.push(_alert);



                if (prompt) {

                    _content.focus();

                }



                _alert.classList.add('m-alert-fade-in');

                setTimeout(() => {

                    _alert.classList.remove('m-alert-fade-in');

                }, 300);

            })

        },

        confirm(message, title) {

            if (typeof title == 'undefined') {

                title = '';

            }



            return this.alert(message, title, 'confirm');

        },

        prompt(title, content) {

            if (typeof content == 'undefined') {

                content = '';

            }



            return this.alert(content, title, 'prompt');

        },

        notify(message, type) {

            let _getIcon = (name) => {

                let svg = {

                    color: '',

                    path: ''

                };



                if (name == 'info') {

                    svg.color = '#1CADF2';

                    svg.path = 'M512,72C269,72,72,269,72,512s197,440,440,440s440-197,440-440S755,72,512,72z M581,673.9 c-33.2,49.9-67,88.3-123.8,88.3c-38.8-6.3-54.7-34.1-46.3-62.4L484,457.6c1.8-5.9-1.2-12.3-6.6-14.2c-5.4-1.9-15.9,5.1-25.1,15.1 l-44.2,53.2c-1.2-8.9-0.1-23.7-0.1-29.6c33.2-49.9,87.8-89.2,124.8-89.2c35.2,3.6,51.8,31.7,45.7,62.6l-73.6,243.3 c-1,5.5,1.9,11.1,6.9,12.8c5.4,1.9,16.8-5.1,26-15.1l44.2-53.1C583,652.3,581,667.9,581,673.9z M571.2,357.6 c-28,0-50.6-20.4-50.6-50.4c0-30,22.7-50.3,50.6-50.3c28,0,50.6,20.4,50.6,50.3C621.8,337.3,599.1,357.6,571.2,357.6z';

                } else if (name == 'success') {

                    svg.color = '#17B77E';

                    svg.path = 'M512,72C269,72,72,269,72,512s197,440,440,440s440-197,440-440S755,72,512,72L512,72z M758.9,374 c-48.5,48.6-81.2,76.9-172.3,186.8c-52.6,63.4-102.3,131.5-102.7,132L462.1,720c-4.6,6.1-13.5,6.8-19.1,1.6L267.9,558.9 c-17.8-16.5-18.8-44.4-2.3-62.2s44.4-18.8,62.2-2.3l104.9,97.5c5.5,5.1,14.1,4.5,18.9-1.3c16.2-20.1,38.4-44.5,62.4-68.6 c90.2-90.9,145.6-139.7,175.2-161.3c36-26.2,77.3-48.6,87.3-36.2C792,343.9,782.5,350.3,758.9,374L758.9,374z';

                } else if (name == 'warning') {

                    svg.color = '#FFC603';

                    svg.path = 'M512,952C269,952,72,755,72,512S269,72,512,72s440,197,440,440S755,952,512,952z M510,770.8 c30.4,0,55-24.6,55-55s-24.6-55-55-55s-55,24.6-55,55S479.6,770.8,510,770.8z M509.8,255.3c-39.3,0-71.2,31.9-71.2,71.2 c0,3.1,0.2,6.2,0.6,9.3L472.4,588c2.5,19.3,18.9,33.7,38.4,33.7c19.4,0,35.8-14.4,38.2-33.7l31.8-252.2c5-39.2-22.8-75-62-79.9 C515.9,255.5,512.8,255.3,509.8,255.3z';

                } else if (name == 'error') {

                    svg.color = '#F56C6C';

                    svg.path = 'M512,952C269,952,72,755,72,512S269,72,512,72s440,197,440,440S755,952,512,952z M579.7,512l101.6-101.6 c18.7-18.7,18.7-49,0-67.7c-18.7-18.7-49-18.7-67.7,0l0,0L512,444.3L410.4,342.7c-18.7-18.7-49-18.7-67.7,0s-18.7,49,0,67.7 L444.3,512L342.7,613.6c-18.7,18.7-18.7,49,0,67.7c18.7,18.7,49,18.7,67.7,0L512,579.7l101.6,101.6c18.7,18.7,49,18.7,67.7,0 c18.7-18.7,18.7-49,0-67.7L579.7,512z';

                } else {

                    return '';

                }



                let str = `

							<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" style="color: ${svg.color}">

							    <path fill="currentColor" d="${svg.path}" />

							</svg>

						`;



                return str;

            }



            let list_type = ['info', 'success', 'warning', 'error'];



            if (list_type.indexOf(type) == -1) {

                type = '';

            }



            let position = 'bottom-center';

            let duration = 2000;



            let _icon = '';

            let _html = '';



            if (type != '') {

                _icon = _getIcon(type);

            }



            if (_icon != '') {

                _html += '<div class="m-notify-icons">' + _icon + '</div>';

            }



            let _content = document.createElement('div');

            _html += '<div class="m-notify-content">';

            _html += '	<div class="m-notify-description">' + message + '</div>';

            _html += '</div>'



            let _wrap = document.createElement('div');

            _wrap.className = 'm-notify-wrapper';

            _wrap.innerHTML = '<div class="m-notify">' + _html + '</div>';



            if (!this.notify_container[position]) {

                let _container = document.createElement('div');

                _container.className = 'm-notify-container is-' + position;



                document.body.appendChild(_container);



                this.notify_container[position] = { el: _container, child: [] };

            }



            if (this.notify_container[position].child.length == 0) {

                this.notify_container[position].el.appendChild(_wrap);

                this.notify_container[position].child.push(_wrap);

            } else {

                let firstChild = this.notify_container[position].child[0];

                this.notify_container[position].el.insertBefore(_wrap, firstChild);

                this.notify_container[position].child.unshift(_wrap);

            }



            _wrap.classList.add('m-notify-fade-in');

            setTimeout(() => {

                _wrap.classList.remove('m-notify-fade-in');

            }, 300);



            setTimeout(() => {

                _wrap.classList.add('m-notify-fade-out');



                setTimeout(() => {

                    let len = this.notify_container[position].child.length;

                    this.notify_container[position].child[len - 1].remove();

                    this.notify_container[position].child.pop();



                    setTimeout(() => {

                        if (this.notify_container[position] && this.notify_container[position].child.length == 0) {

                            this.notify_container[position].el.remove();

                            this.notify_container[position] = null;

                        }

                    }, 3000);

                }, 290);

            }, duration);

        },

        showError401(err) {

            if (this.show_error_401) {

                return false;

            }



            this.show_error_401 = true;

            this.alert(err, '', 'error').then(() => {

                this.$router.replace({ name: 'login' });

            });



            return true;

        },

        showError(err) {
            if (err && err.handled) return;

            if (!err) {
                this.alert('Error', '', 'error');
                return;
            }



            let error = err;

            let status = 200;



            if (err.response) {

                if (err.response.status) {

                    status = err.response.status;

                }



                if (err.response.data) {

                    if (err.response.data.message) {

                        error = err.response.data.message;

                    }

                }

            }



            if (status == 401) {

                this.setAuth(null);



                return this.showError401(error);

            }



            this.alert(error, '', 'error');

        },

        enablePullRefresh(enable) {

            if ('AppJS' in window) {

                try {

                    AppJS.setEnableRefresh(enable);

                } catch (e) { }

            }

        },

        getApp() {

            return this.$children[0];

        },

        md5(string) {

            return Md5(string);

        },

        validatePhone(phone) {

            let regex = /^0[0-9]{9,}$/;

            if (regex.test(phone)) {

                return true;

            }



            return false;

        },

        validateEmail(email) {

            let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

            if (regex.test(email)) {

                return true;

            }



            return false;

        },

        getCookie(name) {

            let data = this.$cookie.get(name);

            if (data) {

                try {

                    data = Utf8.decode(Base64.decode(data));

                    return data;

                } catch (e) { }

            }



            return null;

        },

        setCookie(name, data, day) {

            if (!day) {

                day = 1;

            }



            data = Base64.encode(Utf8.encode(data));

            this.$cookie.set(name, data, day);

        },

        deleteCookie(name) {

            this.$cookie.delete(name);

        },

        login(username, password) {

            return new Promise((resolve, reject) => {

                let data = { username, password };

                this.api.post('logach/user/login', data).then(res => {

                    if (res.data.status == 'OK') {

                        this.setAuth(res.data.auth);

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        logout() {

            return new Promise((resolve, reject) => {

                this.api.post('logach/user/logout').then(res => {
                    this.setAuth(null);
                    resolve(res.data);
                }).catch(err => {
                    this.setAuth(null);
                    reject(err);
                });

            })

        },

        register(data) {

            return new Promise((resolve, reject) => {

                this.api.post('user/register', data).then(res => {

                    if (res.data.status == 'OK') {

                        this.setAuth(res.data.auth);

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        lostpass(data) {

            return new Promise((resolve, reject) => {

                this.api.post('user/lostpass', data).then(res => {

                    if (res.data.status == 'OK') {

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        getConfig() {

            return new Promise((resolve, reject) => {

                this.api.get('config').then(res => {

                    console.log(res)

                    if (res.data.status == 'OK') {

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        getMenu(name) {

            return new Promise((resolve, reject) => {

                this.api.get('menu/' + name).then(res => {

                    if (res.data.status == 'OK') {

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        getListPlace(parent_id) {

            return new Promise((resolve, reject) => {

                this.api.get('/place/' + parent_id).then(res => {

                    if (res.data.status == 'OK') {

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            });

        },

        getSlider(name) {

            return new Promise((resolve, reject) => {

                this.api.get('slider/' + name).then(res => {

                    if (res.data.status == 'OK') {

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        getListPost(type_id, cat_id, per, page) {

            if (!page) {

                page = 1;

            }



            return new Promise((resolve, reject) => {

                this.api.get('list', {

                    params: {

                        tid: type_id,

                        cid: cat_id,

                        per,

                        page

                    }

                }).then(res => {

                    if (res.data.status == 'OK') {

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        getListPostInGroup(type_id, group_id, per, page) {

            if (!page) {

                page = 1;

            }



            return new Promise((resolve, reject) => {

                this.api.get('list', {

                    params: {

                        tid: type_id,

                        gid: group_id,

                        per,

                        page

                    }

                }).then(res => {

                    if (res.data.status == 'OK') {

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        getDetailPost(id, number, field) {

            let data = {

                id

            };



            if (number) {

                data.number = number;

            }



            if (field) {

                data.field = (typeof field == 'object') ? JSON.stringify(field) : '';

            }



            return new Promise((resolve, reject) => {

                this.api.post('detail', data).then(res => {

                    if (res.data.status == 'OK') {

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        incrementPost(id) {

            if (this.$cookie.get(this.ck_view + '_' + id)) {

                return;

            }



            this.api.post('increment', { id }).then(res => {

                if (res.data.status == 'OK') {

                    this.$cookie.set(this.ck_view + '_' + id, new Date().getTime());

                }

            }).catch(err => { });

        },

        getPrice(data) {

            return new Promise((resolve, reject) => {

                this.api.post('price', data).then(res => {

                    if (res.data.status == 'OK') {

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        getListSearch(data) {

            return new Promise((resolve, reject) => {

                this.api.get('search', {

                    params: data

                }).then(res => {

                    if (res.data.status == 'OK') {

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        getUserInfo() {

            return new Promise((resolve, reject) => {

                this.api.get('user/info').then(res => {

                    if (res.data.status == 'OK') {

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        updateUserInfo(data) {

            return new Promise((resolve, reject) => {

                this.api.post('user/info', data).then(res => {

                    if (res.data.status == 'OK') {

                        this.auth.name = res.data.auth.name;

                        this.auth.avatar = res.data.auth.avatar;



                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        updateUserPassword(old_password, new_password, re_password) {

            return new Promise((resolve, reject) => {

                let data = { old_password, new_password, re_password };

                this.api.post('user/password', data).then(res => {

                    if (res.data.status == 'OK') {

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        addAreaUser(data) {

            return new Promise((resolve, reject) => {

                this.api.post('user/area/add', data).then(res => {

                    if (res.data.status == 'OK') {

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        deleteAreaUser(id) {

            return new Promise((resolve, reject) => {

                let data = { id };

                this.api.post('user/area/delete', data).then(res => {

                    if (res.data.status == 'OK') {

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        getInfoCart(tid) {

            return new Promise((resolve, reject) => {

                this.api.get('cart/info', {

                    params: { tid }

                }).then(res => {

                    if (res.data.status == 'OK') {

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        calcMoneyShopCart(data) {

            return new Promise((resolve, reject) => {

                this.api.post('cart/money', data).then(res => {

                    if (res.data.status == 'OK') {

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        sendCart(data) {

            return new Promise((resolve, reject) => {

                this.api.post('lagreen/cart/send', data).then(res => {

                    if (res.data.status == 'OK') {

                        // this.$cookie.delete(this.ck_cart);

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        getListOrder(page, per) {

            return new Promise((resolve, reject) => {

                this.api.get('lagreen/order', {

                    params: { page, per }

                }).then(res => {

                    if (res.data.status == 'OK') {

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        sendFeedback(data) {

            return new Promise((resolve, reject) => {

                this.api.post('send-feedback', data).then(res => {

                    if (res.data.status == 'OK') {

                        resolve(res.data);

                    } else {

                        reject(res.data.error, res.data.data);

                    }

                }).catch(err => reject(err));

            })

        },

        getRank() {

            return this.list_rank[this.rank];

        },

        async sleep(ms) {

            return new Promise((resolve, reject) => {

                setTimeout(() => {

                    resolve();

                }, ms);

            })

        },

        getToken() {

            // if ('Android' in window) {

            // 	try {

            // 		AppJS.getToken();

            // 	} catch {}

            // } else if ('webkit' in window) {

            // 	try {

            // 		webkit.messageHandlers.getToken.postMessage('');

            // 	} catch {}

            // }



            // if (this.app_type == 'Android') {

            // 	try {

            // 		AppJS.getToken();

            // 	} catch {}

            // } else if (this.app_type == 'iOS') {

            // 	try {

            // 		window.webkit.messageHandlers.getToken.postMessage('');

            // 	} catch {}

            // }

            // if (this.auth) {

            // 	if (this.auth.phone === '0789137727') {

            // 		this.$notify('Đang tải dữ liệu'+ this.appType);

            // 	}

            // }

            let hotline = '0789137727';

            if (window.appType == 'Android') {

                try {

                    AppJS.callPhone2(hotline);

                    return;

                } catch { }

            } else if (window.appType == 'iOS') {

                try {

                    window.webkit.messageHandlers.callPhone2.postMessage(hotline);

                    return;

                } catch { }

            }



        },

        setToken(token) {

            if (this.auth) {

                if (this.auth.phone === '0789137727') {

                    this.$notify('Cập nhật thành công tu server');

                }

            }

            this.api.post('lagreen/user/token', { token }).then(res => {

                console.log(res);



            }).catch(() => { });

        },

        nl2br(str) {

            // Thay \n bằng <br> để hiển thị trong HTML

            return str ? str.replace(/\n/g, '<br>') : '';

        }

    },

    created() {

        let token = this.$cookie.get(this.ck_auth);

        if (token) {

            try {

                token = Base64.decode(token);

            } catch {

                token = null;

            }

        } else {

            token = null;

        }



        if (token) {

            // MOCK AUTH CHECK
            console.log('Skipping API auth check for mock mode');
            /*
            this.loading_page = true;

            this.api.get('user/auth', {

                headers: {

                    'User-Token': token

                }

            }).then(res => {

                if (res.data.status == 'OK') {

                    this.setAuth(res.data.auth);

                } else {

                    this.setAuth(null);



                    if (this.$route.name != 'login') {

                        this.$router.replace({ name: 'login' });

                    }

                }



                this.loading_page = false;

            }).catch(err => {

                this.loading_page = false;

                this.showError(err);

            });
            */
        }

    },

    mounted() {

        this.page_title = 'Phan mem lo gach';

        this.getConfig();




        if (this.$route.meta.title) {

            document.title = this.$route.meta.title + ' | ' + this.page_title;

        }



        Vue.prototype.$alert = this.alert;

        Vue.prototype.$confirm = this.confirm;

        Vue.prototype.$prompt = this.prompt;

        Vue.prototype.$notify = this.notify;



        this.setSortType('time');

        // --- ADD INTERCEPTOR FOR SINGLE SESSION ENFORCEMENT ---
        this.api.interceptors.response.use(response => {
            if (response.data && response.data.status === 'ERR' && response.data.message === 'Truy cập bị từ chối') {
                const currentToken = this.api.defaults.headers.common['User-Token'];
                const cookieRaw = Cookie.get(this.ck_auth);
                let cookieToken = '';
                if (cookieRaw) {
                    try {
                        const decoded = Base64.decode(cookieRaw);
                        cookieToken = decoded.includes('-') ? decoded.split('-')[1] : decoded;
                    } catch (e) { }
                }

                // Detect if another tab has already logged in (cookie changed)
                const isLoginPage = window.location.href.includes('login') || window.location.hash.includes('login');
                const sessionStillCurrent = cookieToken === currentToken;

                if (this.auth && sessionStillCurrent) {
                    this.setAuth(null);
                    if (!isLoginPage) {
                        this.alert('Phiên làm việc đã hết hạn hoặc tài khoản đã đăng nhập ở nơi khác.', 'Thông báo', 'info').then(() => {
                            window.location.href = '/login';
                        });
                    }
                }

                return Promise.reject({ message: 'SESSION_INVALIDATED', handled: true });
            }
            return response;
        }, error => {
            return Promise.reject(error);
        });



        // tắt scroll-pull-refresh trên android app

        this.enablePullRefresh(false);

    },

    watch: {

        '$route': function (_new, _old) {

            if (_new.meta.title) {

                document.title = _new.meta.title + ' | ' + this.page_title;

            }

        },

        auth(n) {

            if (n) {
                // MOCK RANK
                this.rank = 'diamond';
                this.discount = null;

                /*
                this.api.get('accumulate/membership').then(res => {

                    if (res.data.status == 'OK') {

                        this.rank = res.data.rank;

                        this.discount = res.data.discount;

                    } else {

                        this.rank = 'normal';

                    }

                }).catch(err => this.showError(err));
                */

            } else {

                this.rank = 'normal';

            }

        }

    }

}).$mount('#app');



if (window.appType != '') {

    window._app = _app;

} else {

    window._app = _app;

}

if ('Android' in window || 'webkit' in window) {

    window._app = _app;

}

// const _app = new Vue({
//     router,
//     render: h => h(App),
//     data: {},
//     methods: {
//         getApp() {
//             return this.$children[0];
//         }
//     },
//     created() {},
//     mounted() {

//     },
//     watch: {

//     }
// }).$mount('#app');